import { render, staticRenderFns } from "./CustomerOnboardingTable.vue?vue&type=template&id=57067038&scoped=true&"
import script from "./CustomerOnboardingTable.vue?vue&type=script&lang=ts&"
export * from "./CustomerOnboardingTable.vue?vue&type=script&lang=ts&"
import style0 from "./CustomerOnboardingTable.vue?vue&type=style&index=0&id=57067038&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57067038",
  null
  
)

export default component.exports